<template>
  <div class="cx-div" id="map-social">
    <div class="m-mapitem__social">
      <div class="cx-t01 m-mapitem__subtitle -fade">
        {{$t('media.otherMedia')}}
      </div>
      <ul class="cx-list">
        <li class="cx-list__item" v-if="audio && audio.length > 0">
          <template v-if="audio.length == 1">
            <a class="cx-link" role="button"
              v-if="audio[0].value && audio[0].value.length > 0"
              @click.prevent="triggerAudio(audio[0])"
            >
              <span class="cx-link__icon">
                <i class="fal fa-headphones-alt"></i>
              </span>
              <span>{{$t('media.audioGuide')}}</span>
            </a>
          </template>
          <template v-else>
            <cx-dropdown trigger="click, hover" transition="cv-slidedown" >
              <span class="cx-link__icon">
                <i class="fal fa-headphones-alt"></i>
              </span>
              <span>{{$t('media.audioGuide')}}</span>
              <template slot="content">
                <ul class="cx-list cx-list--vertical cx-t01"
                  :aria-activedescendant="(selectAudioIdx != null && selectAudio != -1) ? `audio-${selectAudioIdx}` : false"
                >
                  <template v-for="(ado, idx) in audio" >
                    <li v-if="ado.value && ado.value.length > 0"
                      :key="`${ado.name}-${ado.value}`">
                      <a :id="`audio-${idx}`"
                        class="cx-link" role="option"
                        @click.prevent="triggerAudio(ado)"
                        :aria-selected="selectAudio == ado.value"
                      >
                        <span>{{ado.name}}</span>
                      </a>
                    </li>
                  </template>
                </ul>
              </template>
            </cx-dropdown>
          </template>
        </li>
        <sight-map-media-btn
          v-if="leaflets && leaflets.length"
          :items="leaflets"
          :label="$t('media.leaflet')"
          icon="fal fa-map"
        ></sight-map-media-btn>
        <sight-map-media-btn
          v-if="apps && apps.length"
          :items="apps"
          :label="$t('media.mobileApp')"
          icon="fal fa-mobile"
        ></sight-map-media-btn>
        <sight-map-media-btn
          v-if="videos && videos.length"
          :items="videos"
          :label="$t('media.video')"
          icon="fal fa-video"
        ></sight-map-media-btn>
        <li class="cx-list__item" v-if="vr">
          <a class="cx-link" :href="vr"
            rel="noopener noreferrer" target="_blank"
          >
            <span class="cx-link__icon">
              <i class="fal fa-bullhorn"></i>
            </span>
            <span>{{$t('media.VR')}}</span>
          </a>
        </li>
        <li class="cx-list__item" v-if="roomRate">
          <a class="cx-link" :href="roomRate"
            rel="noopener noreferrer" target="_blank"
          >
            <span class="cx-link__icon">
              <i class="fal fa-chart-bar"></i>
            </span>
            <span>{{$t('accommodation.roomRate')}}</span>
          </a>
        </li>
        <li class="cx-list__item" 
          v-if="geoInfos && geoInfos.length > 0">
          <template v-if="geoInfos.length == 1">
            <map-button 
              :name="$t(`media.${mapToUse}`)"
              :url="getMapURL(geoInfos[0])"
            ></map-button>
          </template>
          <template v-else>
            <cx-dropdown trigger="click, hover" transition="cv-slidedown">
              <div class="cx-link">
                <span class="cx-link__icon">
                  <i class="fal fa-map"></i>
                </span>
                <span>{{$t(`media.${mapToUse}`)}}</span>
              </div>
              <template slot="content">
                <ul class="cx-list cx-list--vertical cx-t01">
                  <li v-for="info in geoInfos" :key="`${info.name} - ${info.lon}, ${info.lat}`">
                    <map-button 
                      :name="info.name"
                      :url="getMapURL(info)"
                      hideIcon
                    ></map-button>
                  </li>
                </ul>
              </template>
            </cx-dropdown>
          </template>       
        </li>
        <!-- <sight-map-media-btn
          v-if="flowForecast && flowForecast.length"
          :items="flowForecast.map(({name, visitorFlowForecast}) => ({name, link: $t('visitorFlowForecast.link', {id: visitorFlowForecast})}))"
          :label="$t('visitorFlowForecast.name')"
          icon="fal fa-poll-people"
          :forceDropdown="flowForecastForceDropdown"
        ></sight-map-media-btn> -->
        <sight-map-accessibility-button v-if="id" :id="id" @show="showAccessibility" :key="id"/>
        <li class="cx-list__item" v-if="shareUrl || sharePath">
          <share-model 
            :shareUrl="shareUrl || sharePath"
            :extralLink="!!shareUrl"
          >
            <template slot-scope="{open}">
              <a href="#" class="cx-link" @click.prevent="open" role="button">
                <span class="cx-link__icon">
                  <i class="fal fa-share"></i>
                </span>
                <span>{{$t('media.share')}}</span>
              </a>
            </template>
          </share-model>
        </li>
        <li class="cx-list__item" v-if="showSearch">
          <SearchOnOtherSiteDropdown
            v-bind="searchOnOtherSite"
          />
        </li>
      </ul>
      <audio-player 
        v-if="selectAudio && selectAudio.length > 0"
        :audio="selectAudio"
        v-on:cancel="selectAudio = null"
      ></audio-player>
    </div>

    <accessibility-modal
      v-if="accessibilityPOI"
      :detail="accessibilityPOI" :settings="accessibilitySettings"
      @close="accessibilityPOI = null"
    ></accessibility-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import coordtransform from 'coordtransform';
import ShareModel from '@/components/ShareModal';
import SightMapMediaBtn from '@/components/SightMapMediaBtn';
import SearchOnOtherSiteDropdown from '@/components/SearchOnOtherSiteDropdown';
import AudioPlayer from '@/components/AudioPlayer';
import AccessibilityModal from '@/components/AccessibilityModal';
import SightMapAccessibilityButton from '@/components/SightMapAccessibilityButton';

export default {
  name: 'sight-map-media',
  props: {
    searchOnOtherSite: {
      type: Object,
      default: () => ({
        nameZH: '',
        nameEN: '',
      })
    },
    id: {
      type: String,
      default: () => '',
    },
    audio: {
      type: Array,
      default: () => [],
    },
    leaflets: {
      type: Array,
      default: () => [],
    },
    apps: {
      type: Array,
      default: () => [],
    },
    videos: {
      type: Array,
      default: () => [],
    },
    vr: {
      type: Boolean,
      default: false,
    },
    geoInfos: {
      type: Array,
      default: () => [],
    },
    sharePath: {
      type: String,
      default: '',
    },
    shareUrl: {
      type: String,
      default: '',
    },
    roomRate: {
      type: String,
      default: '',
    },
    flowForecast: {
      type: Array,
      default: () => []
    },
    flowForecastForceDropdown: {
      type: Boolean,
      default: false
    }
  },
  uit() {
    return [
      ['media', [
        'audioGuide',
        'leaflet',
        'mobileApp',
        'video',
        'VR',
        'googleMap',
        'aMap',
        'share',
        'otherMedia',
      ]],
      ['visitorFlowForecast', [
        'name',
        'link'
      ]],
      ['accommodation', ['roomRate']],
      ['accessibility', ['barrierFreeTravelGuide']],
      ['common', ['details']],
    ]
  },
  data() {
    return {
      accessibilityPOI: null,
      accessibilitySettings: null,
      selectAudio: null,
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      isGeolocationOn: state => state.geolocation.isGeolocationOn,
      mapBoxGeolocationOn: state => state.geolocation.mapBoxGeolocationOn,
      userLocation: state => state.geolocation.userLocation
    }),
    selectAudioIdx: function() {
      return (this.selectAudio != null && this.audio && this.audio.length > 1)
        ? this.audio.findIndex(a => a.value == this.selectAudio) 
        : null;
    },
    isZhHans: function() {
      return this.$i18n.locale.toLowerCase() == 'zh-hans';
    },
    showSearch: function() {
      return this.searchOnOtherSite.nameZH || this.searchOnOtherSite.nameEN; 
    },
    mapToUse: function() {
      return this.isZhHans ? 'aMap' : 'googleMap'
    }
  },
  components: {
    SightMapMediaBtn,
    SearchOnOtherSiteDropdown,
    ShareModel,
    AccessibilityModal,
    SightMapAccessibilityButton,
    AudioPlayer,
    'map-button': {
      name: 'map-button',
      props: {
        name: { type: String, default: '' },
        url: { type: String, default: '' },
        hideIcon: { type: Boolean, default: false }
      },
      template: `
        <a class="cx-link" target="_blank"
          :href="url">
          <span v-show="!hideIcon" class="cx-link__icon">
            <i class="fal fa-map"></i>
          </span>
          <span>{{name}}</span>
        </a>
      `
    }
  },
  methods: {
    triggerAudio: function({ value } = null) {
      if (value && value.length > 0) {
        this.selectAudio = this.selectAudio == value ? null : value;
      }
    },
    getAudioIcon: function(val) {
      return this.selectAudio == val ? 'fas fa-play' : 'fal fa-headphones-alt';
    },
    getMapURL: function(info) {
      return this[this.mapToUse + 'URL']
        ? this[this.mapToUse + 'URL'](info)
        : '';
    },
    googleMapURL: function({name, lon, lat}) {
      // if (this.isMobile && this.isIOS()) 
      //   return `comgooglemaps://?daddr=${lon},${lat}&directionsmode=transit`
        
      return `https://maps.google.com/maps/dir/?api=1&destination=${lon},${lat}&travelmode=transit`
    },
    aMapURL: function({name, lon, lat}) {
      let protocol = 'https';
      let gcj = coordtransform.wgs84togcj02(lat, lon);

      if (this.isMobile) {
        // need to transform the wgs to gcj
        // Since m.amap.com can't feed coordinate
        return `${protocol}://uri.amap.com/navigation?to=${gcj[0]},${gcj[1]},${name}&mode=bus&coordinate=wgs84&callnative=1`
      } else {
        return (this.mapBoxGeolocationOn
            // need to transform the wgs to gcj
            // Since m.amap.com can't feed coordinate
            ? `${protocol}://uri.amap.com/navigation?from=${this.userLocation[0]},${this.userLocation[1]},我的位置&to=${gcj[0]},${gcj[1]},${name}&mode=bus&coordinate=wgs84&callnative=1`
            : `${protocol}://uri.amap.com/marker?position=${lat},${lon}&name=${name}&coordinate=wgs84&callnative=1`)
      }
    },
    showAccessibility({ poi, settings }) {
      this.accessibilityPOI = poi;
      this.accessibilitySettings = settings;
    },
  },
  watch: {
    audio: {
      deep: true,
      handler: function(val) {
        if (!val.find(a => a.value == this.selectAudio)) {
          this.selectAudio = null;
        }
      }
    },
  },
}
</script>

<style lang="scss">
  #map-social .m-dropdown__content{
    min-width: 300px;
  }
</style>